import { ArrowRight, Construction } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/ui/misc";
import type { NavItem } from "@/lib/nav";
import { t } from "@shared/i18n";

const DETAILS: Record<string, string[]> = {
  planning: [t("Vues jour / semaine / mois"), t("Événements récurrents et rappels"), t("Planification IA (basique, avancée, priorités)"), t("Détection de surcharge, mode Deep Work"), t("Google Calendar et Outlook (OAuth)")],
  tasks: [t("Tâches avec priorité 1–5, durées, dépendances"), t("Projets et historique des modifications"), t("Replanification intelligente"), t("Outils du Coach : create_task, update_task…")],
  finance: [t("Transactions, catégories, filtres"), t("Import CSV avec prévisualisation et détection de doublons"), t("Prévisionnel de trésorerie 30/60/90 jours (3 scénarios)"), t("Détecteur de risques et simulateur de décisions")],
  documents: [t("Devis, factures, propositions, contrats…"), t("Génération IA contextuelle, versionnage"), t("Contrôle qualité avant export"), t("Export PDF / DOCX")],
  files: [t("Dossiers, téléversement, prévisualisation"), t("Stockage privé S3, quotas, liens temporaires"), t("Recherche sémantique (RAG) avec citations")],
  automations: [t("Déclencheurs, conditions, actions"), t("Validation humaine des actions sensibles"), t("Journal d'exécution, suspension immédiate")],
  goals: [t("Objectifs, indicateurs, jalons"), t("Score de progression transparent et configurable"), t("Bilan hebdomadaire")],
  team: [t("Invitations, rôles et permissions"), t("Projets et tâches partagés"), t("Copilote d'équipe")],
  integrations: [t("Google, Microsoft, Slack, Notion, Trello, Dropbox"), t("Stripe (abonnements)"), t("Architecture d'adaptateurs, OAuth, moindre privilège")],
  notifications: [t("Centre de notifications unifié"), t("Rappels planifiés côté serveur (jobs persistants)"), t("Préférences par type et fréquence")],
};

/** État explicite d'un module pas encore livré : aucune fonctionnalité simulée. */
export function ModuleComingSoon({ item }: { item: NavItem }) {
  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-8 sm:py-10">
      <PageHeader eyebrow={t("Phase {0} de la feuille de route", item.phase)} title={item.label} description={item.description} />
      <div className="mt-8 rounded-xl border border-dashed border-border-strong p-6 sm:p-8">
        <div className="flex size-11 items-center justify-center rounded-xl bg-surface text-muted">
          <Construction className="size-5" />
        </div>
        <h2 className="mt-4 text-lg font-semibold">{t("Module en cours de développement")}</h2>
        <p className="mt-1.5 max-w-xl text-sm text-muted">
          {t("Ce module n'est pas encore disponible. Plutôt que d'afficher une maquette ou des données fictives, nous le livrerons lorsqu'il sera réellement fonctionnel et testé.")}
        </p>
        {DETAILS[item.id] && (
          <ul className="mt-6 grid gap-2 sm:grid-cols-2">
            {DETAILS[item.id].map((d) => (
              <li key={d} className="flex gap-2 text-sm">
                <span className="mt-2 size-1.5 shrink-0 rounded-full bg-brand" /> {d}
              </li>
            ))}
          </ul>
        )}
        <Link to="/app/coach?new=1" className="mt-8 inline-flex">
          <Button variant="secondary">
            {t("En attendant, en parler au Coach IA")} <ArrowRight className="size-4" />
          </Button>
        </Link>
      </div>
    </div>
  );
}
